var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 215.1 162.9",
    style: {
      enableBackground: "new 0 0 215.1 162.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#F9F1E1;}\n\t.st3{fill:#EAF4FE;}\n\t.st4{fill:none;stroke:#0561FC;stroke-width:6.8376;stroke-miterlimit:10;}\n\t.st5{fill:#0561FC;}\n\t.st6{fill:#C5E1F9;}\n\t.st7{fill:#7EB3FF;}\n\t.st8{fill:#B5D5EA;}\n\t.st9{fill:#E1EBF4;}\n\t.st10{fill:#9AC7F7;}\n\t.st11{fill:none;stroke:#0561FC;stroke-width:6.8376;}\n\t.st12{fill:none;stroke:#7EB3FF;stroke-width:6.8376;}\n\t.st13{fill:none;stroke:#0561FC;stroke-width:6.8376;stroke-linecap:round;}\n\t.st14{fill:none;stroke:#0561FC;stroke-width:7.1001;}\n\t.st15{fill:#B6D9EF;}\n\t.st16{fill:none;stroke:#9AC7F7;stroke-width:6.8376;}\n\t.st17{fill:none;stroke:#0561FC;stroke-width:6.8376;stroke-linejoin:bevel;}\n\t.st18{fill:none;stroke:#0561FC;stroke-width:6.8376;stroke-linecap:round;stroke-linejoin:round;}\n\t.st19{fill:none;stroke:#0561FC;stroke-width:5.0237;}\n\t.st20{fill:none;stroke:#0450CF;stroke-width:6.8376;}\n\t.st21{fill:none;stroke:#C5E1F9;stroke-width:6.8376;}\n\t.st22{fill:#FFBF0D;}\n\t.st23{fill:#B2D2EA;}\n\t.st24{fill:none;stroke:#0561FC;stroke-width:6.9311;}\n\t.st25{fill:none;stroke:#0561FC;stroke-width:6.8376;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st26{fill:#FFFFFF;}\n\t.st27{fill:#FFFFFF;stroke:#0561FC;stroke-width:6.8376;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: -42.4,
    className: "st2",
    width: 218.8,
    height: 218.8
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M211.6,33.6v110.8c0,8.3-6.7,15-15,15H18.6c-8.3,0-15-6.7-15-15V33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M199.9,0H15.2c-8.3,0-15,6.7-15,15v14.9H215V15C215,6.7,208.3,0,199.9,0z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 21.3,
    y1: 15.9,
    x2: 16.2,
    y2: 15.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 32.1,
    y1: 15.9,
    x2: 27.1,
    y2: 15.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 43,
    y1: 15.9,
    x2: 37.9,
    y2: 15.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "82,113.1 64.7,103.1 47.4,93.1 64.7,83.1 82,73.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "123.2,113.1 140.5,103.1 157.8,93.1 140.5,83.1 123.2,73.1  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 115.5,
    y1: 59.7,
    x2: 89.1,
    y2: 126.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d9270c9eed9f8ad3e1c1ed151eac2c1d.svg";
export { ForwardRef as ReactComponent };